import { createSlice } from '@reduxjs/toolkit';
import { SalesRep } from '@dill/dill-shared';
import {
  getSupplierSalesRepsExtraReducer,
  createSalesRepExtraReducer,
  updateSalesRepExtraReducer,
  deleteSalesRepExtraReducer,
} from '../reducers/supplierAdditionalDetailsReducers';

export interface SalesRepInitialState {
  loadingList: string[];
  error: string | null;
  salesReps: SalesRep[];
}

const initialState: SalesRepInitialState = {
  loadingList: [],
  error: null,
  salesReps: [],
};

export const salesRepSlice = createSlice({
  name: 'salesReps',
  initialState,
  reducers: {
    resetSalesRepRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierSalesRepsExtraReducer(builder);
    createSalesRepExtraReducer(builder);
    updateSalesRepExtraReducer(builder);
    deleteSalesRepExtraReducer(builder);
  },
});

export const { resetSalesRepRootState } = salesRepSlice.actions;
